import sectionBar from './section-bar/store';
import sectionProduct from './section-product/store';
import navigation from './navigation/store';
import retrieval from './retrieval/store';

export default {
  namespaced: true,
  modules: { sectionBar, sectionProduct, navigation, retrieval },
};
